import axios from 'axios';
import constants from '$lib/constants';

export async function getScoutToken() {
	const options = {
		url: `${constants.API_URL}/scout/token`,
		method: 'GET',
		isAuthenticated: true,
		headers: {
			'Content-Type': 'application/json',
		},
	};

	const { data } = await axios(options);

	return data.accessToken;
}
